// src/index.ts
var GLOBAL_CONFIG_VAR = "__WIPPY_APP_CONFIG__";
var GLOBAL_PROXY_CONFIG_VAR = "__WIPPY_PROXY_CONFIG__";
var GLOBAL_API_PROVIDER = "__WIPPY_APP_API__";
var GLOBAL_WEB_COMPONENT_CACHE = "__WIPPY_WEB_COMPONENT_CACHE__";
var WIPPY_SCRIPTS_DATA_ROLE = "@wippy/scripts";
var WIPPY_PACKAGE_DATA_ROLE = "@wippy/package";
export {
  GLOBAL_API_PROVIDER,
  GLOBAL_CONFIG_VAR,
  GLOBAL_PROXY_CONFIG_VAR,
  GLOBAL_WEB_COMPONENT_CACHE,
  WIPPY_PACKAGE_DATA_ROLE,
  WIPPY_SCRIPTS_DATA_ROLE
};
//# sourceMappingURL=index.js.map